import { useEffect, useState } from "react";
import {
  EditPatientTestsRequest,
  GetPatientTestsResponse,
  PatientTests,
  PatientTestsApi,
} from "../../../api/medical-operations";
import { useRecoilValue } from "recoil";
import { configState } from "../../../recoil/atoms";
import PatientTest from "./Forms/PatientTestForm";
import { Form, Formik } from "formik";
import { Button, Grid, LinearProgress, Typography } from "@mui/material";
import useStyles from "../../../styles/styles";
import { Box } from "@mui/system";
import { validationSchema } from "./FormModel/validationSchema";
import { toast } from "react-toastify";

type Props = {
  initialPatientTestValues?: PatientTests | any;
};

const EditPatientTests = ({ initialPatientTestValues }: Props) => {
  const config = useRecoilValue(configState);
  const classes = useStyles();
  const [patientTest, setPatientTest] = useState<GetPatientTestsResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(true);


  const getPatientTest = () => {
    const PatientTests = new PatientTestsApi(config);
    PatientTests.getPatientTestsById(initialPatientTestValues[0]!)
      .then((res) => {
        setIsLoading(false);
        setPatientTest(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.detail);
      });
  };
  useEffect(() => {
    getPatientTest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const editPatientTest = (values: EditPatientTestsRequest) => {
    const patientTest = new PatientTestsApi(config);
    patientTest
      .editPatientTests(initialPatientTestValues[0]!, values)
      .then((res) => {
        toast.success(res?.data?.Message!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: any, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    const resultDocs = values?.ResultsDocuments!.map(({ UploadedByDoctor, ...keepAttrs }: any) => keepAttrs);
    const valuesEdited: EditPatientTestsRequest = {
      ReleaseDate: values?.ReleaseDate,
      TestID: values?.TestID,
      ResultOutcomes: values?.ResultOutcomes,
      ResultsDocuments: resultDocs,
    };
    editPatientTest(valuesEdited);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ bgcolor: "#fff", p: 1 }}>
          {!isLoading ? (
            <>
              <Typography variant="h3" gutterBottom sx={{ p: 0 }}>
                Edit Patient Test
              </Typography>
              <Formik
                initialValues={patientTest!}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ dirty }) => {
                  return (
                    <Form>
                      <PatientTest />
                      <Grid className={classes.buttons}>
                        <Grid className={classes.wrapper}>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            disabled={!dirty}
                          >
                            Edit Test
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </>
          ) : (
            <LinearProgress color="secondary" />
          )}
        </Box>
      </Box>
    </>
  );
};

export default EditPatientTests;
